<template>
  <v-app>
    <v-layout>
      <v-navigation-drawer app permanent width="280" class="translucent-background d-flex flex-column overflow-hidden">
        <v-sheet class="d-flex pa-4 justify-items-between">
          <v-img src="/assets/logo.png" max-height="48" contain class="" />
        </v-sheet>

        <v-list nav density="compact">
          <v-list-item
            v-for="item in navItems"
            density="compact"
            class="py-1 my-0 navigation-item"
            :key="item.to"
            :href="item.to"
            :prepend-icon="item.icon"
            :active="globalProps.currentPath === item.to"
            :title="item.label"
          />
        </v-list>

        <div
          id="context-navigation-container"
          style="display: flex; flex: 1 1 0; min-height: 0; flex-direction: column; overflow: hidden;"
        ></div>

        <template #append>
          <div class="text-right text-grey-100 text-caption text-medium-emphasis pe-2 pb-1">{{ globalProps.version }}</div>
          <v-divider />
          <v-sheet class="pa-3 bg-transparent">
            <div class="text-body-2">{{ globalProps.currentUser?.email }}</div>
            <div class="text-caption text-medium-emphasis">{{ globalProps.currentUser?.organisation_name }}</div>
            <v-form class="mt-3" method="post" :action="globalProps.logoutPath">
              <input type="hidden" name="_method" value="delete">
              <input type="hidden" name="authenticity_token" :value="globalProps.csrfToken">
              <v-btn block color="secondary" variant="tonal" type="submit">Logout</v-btn>
            </v-form>

          </v-sheet>
        </template>
      </v-navigation-drawer>

      <v-main>
        <v-container fluid class="py-4 px-4 px-md-8">
          <v-alert
            v-if="globalProps.flash?.alert"
            type="error"
            variant="tonal"
            class="mb-4"
          >
            {{ globalProps.flash.alert }}
          </v-alert>
          <v-alert
            v-if="globalProps.flash?.notice"
            type="success"
            variant="tonal"
            class="mb-4"
          >
            {{ globalProps.flash.notice }}
          </v-alert>

          <slot />
        </v-container>
      </v-main>
    </v-layout>
  </v-app>
</template>

<script setup>
  defineProps({
    globalProps: {
      type: Object,
      required: true,
    },
    navItems: {
      type: Array,
      required: true,
    },
  });
</script>

<style scoped>
  :deep(.v-navigation-drawer__content) {
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
  }

  .v-list-item.navigation-item {
    min-height: 25px !important;
  }

  .translucent-background {
    background-color: rgba(255, 255, 255, 0.8);
  }
</style>
